module.exports = new __parcel__URL__("stardust_prog_bar.04312c2a.png").toString();